import { renderVueComponent } from "@/lib/renderVueComponent.js";
import { onReady } from "@/lib/turbo.js";

import LoginForm from "@/Login/LoginForm.vue";
import store from "@/vuex/store";

onReady(() => {
  renderVueComponent("login", LoginForm, { store });
});
